import { styled } from '../../Utilities';
import { getStyles } from './Rating.styles';
import { RatingBase } from './Rating.base';
export var Rating = styled(RatingBase, getStyles, undefined, { scope: 'Rating' });
//# sourceMappingURL=Rating.js.map